import type { IRevealStatusDropdownTreeNode } from "./type";

export const revealStatusDropdownLabels: Record<string, string> = {
    includeOnlyNotRevealed: "si.account-overview.filters.reveal-status.not-revealed",
    includeOnlyRevealed: "si.account-overview.filters.reveal-status.revealed",
    includeOnlyExported: "si.account-overview.filters.reveal-status.exported",
    excludeExported: "si.account-overview.filters.reveal-status.not-exported",
};

export const revealStatusDropdownTree: IRevealStatusDropdownTreeNode[] = [
    {
        id: "includeOnlyNotRevealed",
        title: revealStatusDropdownLabels.includeOnlyNotRevealed,
    },
    {
        id: "includeOnlyRevealed",
        title: revealStatusDropdownLabels.includeOnlyRevealed,
        children: [
            {
                id: "includeOnlyExported",
                title: revealStatusDropdownLabels.includeOnlyExported,
            },
            {
                id: "excludeExported",
                title: revealStatusDropdownLabels.excludeExported,
            },
        ],
    },
];
